/**
 * Journal — scroll reveal.
 *
 * Fails open on purpose: a safety timer marks everything visible after 1.5s
 * whether or not the observer ever fired. The theme does soft page transitions,
 * and a reveal that only runs on hard load would otherwise leave a whole
 * section stuck at opacity 0.
 */

function arm(root) {
  const els = (root || document).querySelectorAll('.jn-reveal:not(.in)');
  if (!els.length) return;

  const io = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('in');
        io.unobserve(entry.target);
      });
    },
    { threshold: 0.08 }
  );

  els.forEach((el) => io.observe(el));

  setTimeout(() => {
    els.forEach((el) => el.classList.add('in'));
    io.disconnect();
  }, 1500);
}

document.documentElement.classList.add('jn-armed');
arm(document);

// Theme editor re-renders a section without a page load.
document.addEventListener('shopify:section:load', (event) => arm(event.target));
